export const en = {
    navbar: {
        choose_language: 'Choose Your Preferred Language!!',
        lang: 'Language',
        list: 'Menu List',
        home: 'Home',
        product: 'Product',
        category: 'Category',
        products: 'Products',
        request: 'Request Order',
        series: 'Series',
        character: 'Character',
        search: 'Search Product..',
        keyword: 'Type any keyword...',
        cart: 'Cart',
        login: 'Login',
        register: 'Register',
        dropdown: {
            request: 'Request Order',
            list_order: 'List Order',
            wishlist: 'Wishlist',
            profile: 'Profile',
            address: 'Address',
            logout: 'Logout',
            cart: 'My Cart',
            cart_detail: 'More Detail'
        },
        message: 'Message',
        empty: {
            title: 'Cart Empty',
            desc: 'Time to add more Product Now!'
        },
        stores: {
            tokopedia: 'Tokopedia',
            booth: 'Booth',
            offline_store: 'Offline Store'
        }
    },
    section: {
        custom: {
            heading: 'World Wide',
            title: 'Custom Request Order',
            description:
                'We Accept Import Orders from Anywhere, with Japan as the Main Country. Contact for More Info!!',
            button: 'More Info'
        },
        categories: {
            title: 'Categories'
        },
        news: {
            title: 'News & Events'
        },
        view: 'View All',
        read: 'Readmore'
    },
    login: {
        title: 'Login',
        email: 'Email',
        password: 'Password',
        cta: 'Sign In',
        remember: 'Remember Me',
        forgot: 'Forgot Password?',
        or: 'Or Login With',
        register: 'Have Account?',
        register_desc:
            'Register Now And Get Access To Our Exclusive Products!!',
        register_cta: 'Register Now',
        account: 'Account'
    },
    register: {
        title: 'Register',
        first: 'First Name',
        last: 'Last Name',
        email: 'Email',
        phone: 'Phone Number',
        password: 'Password',
        confirm: 'Confirm Password',
        cta: 'Sign Up',
        login: 'Have Account?',
        login_desc: 'Login to Continue Shopping',
        login_cta: 'Login Here'
    },
    product: {
        title: 'All Product',
        price: 'Price',
        filter: {
            newest: 'Newest',
            most_buy: 'Most Buy',
            popular: 'Popular',
            discount: 'Discount',
            pre_order: 'Pre-Order',
            ready_stock: 'Ready Stock',
            lowest_price: 'Lowest Price',
            highest_price: 'Highest Price',
        },
        cta: 'Load More Product',
        empty: {
            title: 'Product Not Available',
            desc: 'We are sorry, the product you are looking for is not available at the moment'
        }
    },
    shorts: {
        title: 'Checkout Our Shorts',
        cta: 'View All Shorts'
    },
    search: {
        filter: {
            title: 'Filter Product',
            close: 'Close',
            min: 'Min Price',
            max: 'Max Price',
            category: 'Category',
            series: 'Series',
            character: 'Character',
            condition: 'Condition',
            other: 'Other',
            stock: 'Ready Stock',
            order: 'Pre-Order',
            apply: 'Apply Filter',
            clear: 'Clear Filter'
        },
        sort: {
            title: 'Sort',
            relevant: 'Relevant',
            newest: 'Newest',
            price_high: 'Highest Price',
            price_low: 'Lowest Price'
        }
    },
    request: {
        title: 'Custom Request Order',
        search: 'Search Order',
        product_url: 'Please provide the link to the item you desire!',
        brief: 'Hmm, What is that item?',
        brief_placeholder:
            'Please fill in the field below so Xiaoken can understand the item you want.',
        name: 'Product Name',
        name_placeholder: 'Input Product Name',
        price: 'Price',
        quantity: 'Quantity',
        quantity_placeholder: 'Total Quantity',
        shipping: 'Where would you like it to be shipped?',
        notice: 'Notice',
        notice_desc:
            'We will inform the detail about your custom request order in whatsapp such as shipping, rates and the total payment. Please make sure your phone number is correct.',
        cta: 'Send Request',
        slider_title:
            'Shopping from anywhere is as easy as copying the link!',
        slider_desc:
            'You can shop for items from various marketplaces such as Amazon, Rakuten, and more. Simply copy the link of the item you desire and paste it in the field above.',
        history: 'History',
        guide: 'Guide',
        status: {
            all: 'All',
            approved: 'Approved',
            pending: 'Pending',
            canceled: 'Canceled'
        },
        reset: 'Reset Filter',
        history_number: 'Order Number',
        history_link: 'Product Link',
        history_chat: 'Chat Seller',
        history_empty: 'History Empty',
        history_empty_desc: "No Custom Order Yet, Let's Add Order!!"
    },
    product_page: {
        product: 'Product',
        detail: {
            title: 'Product Details',
            category: 'Category',
            sku: 'SKU',
            min_order: 'Min Order',
            condition: 'Condition',
            condition_new: 'New',
            condition_used: 'Used',
            status: {
                duration: 'Duration',
                days: 'Days'
            },
            character: 'Character',
            stock: 'Stock',
            stock_out: 'Out of Stock',
            size: 'Size (L.W.H)',
            weight: 'Weight',
            tags: 'Tags'
        },
        select: 'Select',
        quantity: 'Quantity',
        order_notes: 'Order Notes',
        notes_placeholder: 'Write your order notes here...',
        add_cart: 'Add to Cart',
        wishlist: 'Wishlist',
        checkout_now: 'Checkout Now',
        desc: 'Product Description',
        share: 'Share',
        similar: 'Similar Product',
        recent: 'Recent Viewed Product',
        interest: 'You Might Interested',
        free_shipping: {
            title: 'Free Shipping Available',
            desc: 'Get FREE shipping on orders over',
            amount: '$650 USD'
        }
    },
    checkout: {
        title: 'Checkout Order',
        add: 'Add Product',
        shipment: 'Shipment',
        payment: 'Payment',
        status: 'Status',
        cart: {
            title: 'Shopping Cart',
            selected: 'Selected',
            empty: 'Your Cart is Empty',
            empty_desc: 'Time to add more Product Now!',
            cta: 'Proceed to Shipment'
        },
        table: {
            product: 'Product',
            variant: 'Variant',
            weight: 'Weight',
            quantity: 'Quantity',
            action: 'Action',
            shopping_total: 'Shopping Total',
            total_weight: 'Total Weight',
            alert: 'Remove Product to Continue',
            notes: 'Notes',
            stock_out: 'Out of Stock',
            back: 'Continue Shopping'
        }
    },
    summary: {
        title: 'Order Summary',
        coupon: 'Coupon Code',
        shop_total: 'Shopping Total',
        ship_cost: 'Shipping Cost',
        insurance: 'Insurance Cost',
        discount: 'Discount',
        pack: "Packing Fee's",
        gov_tax: 'Gov Tax',
        payment_fee: 'Payment Fee',
        grand: 'Grand Total',
        apply_coupon: 'Apply Coupon',
        coupon_applied: 'Coupon Applied',
        items: 'items',
        free_shipping: 'Free Shipping',
        select_expedition: 'Select expedition',
        tooltip: {
            free_shipping: 'Get <b>Free Shipping</b> if your total purchase is above ',
            insurance_fee: 'Product with insurance will be charged a fee of',
            minimum: 'Minimum',
            tax_fee: 'Product without tax will be charged a fee of',
            paypal_fee: 'We add additional fees to match <b class="capitalize">{method}</b>. The fee is ',
            final_payment: 'based on Final Payment'
        }
    },
    shipment: {
        title: 'Shipment',
        address: 'Shipping Address',
        page: 'My Address',
        empty: 'Your Address is empty',
        empty_desc: 'Please add atleast one address to complete the order',
        card: {
            type: 'Type',
            primary: 'Primary',
            selected: 'Selected',
            receipt: 'Recipient',
            country: 'Country',
            province: 'Province',
            city: 'City',
            address: 'Address',
            detail: 'Detail Address',
            postal: 'Postal Code',
            cta: 'Select Different Address'
        },
        form: {
            list: 'List Address',
            add: 'Add New Address',
            update: 'Update Address',
            type: 'Adddress Type',
            receipt: 'Recipient Name',
            email: 'Recipient Email',
            phone: 'Phone Number',
            country: 'Country',
            province: 'Province',
            city: 'City',
            postal: 'Postal Code',
            address: 'Address',
            detail: 'Building Number / Floor / Unit',
            main: 'Set as Main Address',
            yes: 'Yes',
            no: 'No',
            cta: 'Add Address',
            cta2: 'Update Address',
            notice_email:
                'Any information regarding the shipment and delivery will be sended to this email',
            notice_phone:
                'Input using international format, e.g. 628123456789'
        },
        expedition: {
            title: 'Choose Expedition',
            sent: 'Sent From',
            destination: 'Destination to',
            estimate: 'Estimate',
            days: 'Days'
        },
        method: 'Payment Method',
        notes: 'Shipping Notes',
        notes_placeholder: 'Write your shipping notes here...',
        cta: 'Pay Now',
        insurance: {
            title: 'Shipping Insurance',
            active: 'Activate Insurance',
            fee: 'Insurance Fee',
            desc: 'One of the products you buy requires insurance, for safer delivery at',
            yes: 'Yes',
            no: 'No'
        }
    },
    payment: {
        guide: 'Payment Guide',
        title: 'Payment Order',
        close: 'Closed in',
        invoice: 'Check Invoice',
        days: 'Days',
        hour: 'h',
        minute: 'm',
        second: 's',
        expirate: 'Payment Expired',
        notice: 'Thank you for placing an order. We kindly remind you to complete the payment for your order before the upcoming deadline. Dont forget to upload Payment Proof in the box below.',
        upload: 'Upload Payment Proof',
        uploaded: 'Your Payment Proof',
        total: 'Total Payment'
    },
    status: {
        expirate: 'Your Payment time is up',
        expirate_desc:
            'Your payment time has expired, please place a new order',
        expirate_cta: 'Place New Order',
        reject: 'Your Payment is not Valid',
        reject_desc: 'Please upload new payment proof',
        reject_cta: 'Upload Payment Proof',
        pending: 'Your Payment is being Processed',
        pending_desc:
            'Please wait for a moment our team will check your payment',
        pending_cta: 'Buy Another Product',
        paid: 'Congratulations. Your Payment is accepted',
        paid_desc:
            'Thanks for ordering in XiaokenShop. We will process your order as soon as possible.',
        paid_cta: 'Track Order'
    },
    order: {
        title: 'Order History',
        search: 'Search Order',
        empty: 'Your Order List is Empty',
        empty_desc: 'Please Add New Order!',
        cta: 'Add Product',
        status: {
            all: 'All',
            process: 'Process',
            success: 'Completed',
            cancel: 'Canceled',
            failed: 'Failed',
            reset: 'Reset Filter'
        },
        card: {
            price: 'Price',
            shipping: 'Shipping to',
            detail: 'Detail Transaction',
            total: 'Total Payment',
            product: 'Total Product',
            cancel: 'Cancel Order',
            help: 'Order Help',
            pay: 'Pay Now',
            again: 'Order Again'
        },
        detail: {
            title: 'Detail Transaction',
            viewmore: 'View More',
            number: 'Order Number',
            date: 'Order Date',
            order: 'Detail Product',
            shipping: 'Shipping Detail',
            expedition: 'Expedition',
            address: 'Shipping Address',
            payment: 'Payment Detail',
            method: 'Payment Method',
            total: 'Shopping Total',
            shipping_cost: 'Shipping Cost',
            gov: 'Gov Tax',
            payment_fee: 'Payment Fee',
            grand: 'Total Payment',
            discount: 'Discount'
        }
    },
    wishlist: {
        title: 'My Wishlisht',
        empty: 'Your Wishlist is Empty',
        empty_desc: 'Explore our product and find your favorite product!'
    },
    profile: {
        title: 'Update Profile',
        verify: 'Verify account',
        email_not: 'Email Not Verified',
        email_yes: 'Account Verified',
        first: 'First Name',
        last: 'Last Name',
        dob: 'Birthday',
        phone: 'Phone Number',
        password: 'Password',
        confirm: 'Confirm Password',
        cta: 'Update Profile'
    },
    forgot: {
        title: 'Forgot Password?',
        desc: 'Enter your email address and we will send you a link to reset your password.'
    },
    reset: {
        title: 'Reset Password',
        desc: 'Please fill in the field below to reset your password',
        new: 'New Password',
        confirm: 'Confirm New Password',
        cta: 'Change Password'
    },
    footer: {
        address: 'Address',
        shopping: {
            head: 'Shopping',
            home: 'Home',
            request: 'Request Order',
            all_product: 'All Product',
            discount: 'Discount Product'
        },
        about: {
            head: 'About Us',
            about: 'About',
            news: 'News & Event',
            tnc: 'Terms & Conditions',
            privacy: 'Privacy Policy'
        },
        support: {
            head: 'Support',
            shop_guide: 'Shopping Guidelines',
            faq: 'FAQ',
            help: 'Contact Us'
        },
        payment: 'Supported Payment',
        store: 'Our Store',
        follow: 'Follow Us'
    },
}
